import o from "./uk/validation.json.js";
import i from "./uk/units.json.js";
import n from "./uk/notifications.json.js";
import r from "./uk/navigation.json.js";
import s from "./uk/errors.json.js";
import t from "./uk/common.json.js";
const m = { uk: { common: t, errors: s, navigation: r, notifications: n, units: i, validation: o } };
export {
  m as locales
};
//# sourceMappingURL=index.js.map
